import Copy from "components/copy";

export const bankInfoData = (input, translate) => {
  return [
    {
      name: translate("bank-name"),
      value: (
        <span className="caption-12px-regular text-gray-4">
          {input?.bankName}
        </span>
      ),
    },
    {
      name: translate("account-num"),
      value: <Copy data={input?.accountNumber} />,
    },
    {
      name: translate("sheba-num"),
      value: <Copy data={input?.iban} />,
    },
  ];
};
